<template>
    <div class="footer-content">
        <div class="content">
            <div class="title">
                <img src="../assets/logo-footer.webp" alt="logo" />
                Refined AI Company Limited
            </div>
            <div class="text">
                SmileLoan ดำเนินการพัฒนาเทคโนโลยีและบริการลูกค้าโดย Refined AI Company Limited
                บริการสินเชื่อทั้งหมดให้บริการโดย MONEYBAY COMPANY LIMITED
                ซึ่งได้รับใบอนุญาตพิโกไฟแนนซ์จากกระทรวงการคลังแห่งประเทศไทย และอยู่ภายใต้การกำกับดูแลอย่างเป็นทางการ
                เรามุ่งมั่นในการให้บริการที่ปลอดภัย โปร่งใส และเป็นไปตามกฎหมาย
                เพื่อมอบประสบการณ์สินเชื่อส่วนบุคคลที่เชื่อถือได้แก่ผู้ใช้ทุกคน
            </div>
            <div class="item-box">
                <div class="item" v-for="item in list" :key="item.index">
                    <img :src="require('@/assets/footer-icon' + item.index + '.webp')" alt="">
                    {{ item.content }}
                </div>
            </div>
        </div>
        <div class="bottom">
            © 2025 สงวนลิขสิทธิ์ Refined AI Company Limited
        </div>
    </div>
</template>
<script setup>
const list = [
    {
        content: "+66 0836010809",
        index: 1,
    },
    {
        content: "company@refinedai-limited.com",
        index: 2,
    },
    {
        content: "108/8 Sukhumvit Soi 23, Khlong Toei Nuea Subdistrict, Watthana District, Bangkok",
        index: 3,
    }
];
</script>
<style lang="less" scoped>
.footer-content {
    width: 100%;
    height: auto;
    background: url(../assets/footer-bg.webp) no-repeat;
    background-size: 100% 100%;
    padding: 0 270px 10px;
    box-sizing: border-box;

    .content {
        width: 100%;
        padding: 38px 0;
        box-sizing: border-box;
        border-bottom: 1px solid rgba(255, 255, 255, 0.2);

        .title {
            display: flex;
            justify-content: center;
            align-items: center;
            font-weight: bold;
            font-size: 24px;
            color: #FFFFFF;
            line-height: 24px;
            letter-spacing: 1px;
            text-shadow: 0px 1px 0px #333333;
            margin-bottom: 40px;

            img {
                width: 60px;
                height: 60px;
                object-fit: contain;
                margin-right: 17px;
            }
        }

        .text {
            width: 100%;
            font-weight: 500;
            font-size: 14px;
            color: #FFFFFF;
            line-height: 24px;
            margin: 20px auto;
        }

        .item-box {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .item {
                max-width: 325px;
                display: flex;
                align-items: center;
                font-weight: 400;
                font-size: 14px;
                color: rgba(255, 255, 255, 0.8);
                line-height: 14px;
                text-shadow: 0px 1px 0px #333333;

                img {
                    width: 16px;
                    object-fit: cover;
                    margin-right: 8px;
                }
            }
        }
    }

    .bottom {
        margin-top: 14px;
        font-weight: 400;
        font-size: 12px;
        color: #FFFFFF;
        line-height: 18px;
        text-shadow: 0px 1px 0px #333333;
        text-align: center;
    }
}
</style>